<template>
  <div class="cdm-Container">
    <div
      v-if="customDashboardState.userCanManageCustomDashboard"
      class="cdm-DragItem"
      data-export-ignore
    >
      <div class="cdm-Drag">
        <i class="drag-trigger">
          <AppIcon class="cdm-Drag_Icon" height="24" icon-name="drag-next" width="24" />
        </i>
      </div>
    </div>
    <div
      :class="{
        'cdm-Wrapper-reloading': customDashboardState.isReload
      }"
      class="cdm-Wrapper"
    >
      <SkeletonItem
        v-if="customDashboardState.isReload"
        animation-opacity="0.8"
        class="cdm-Wrapper_Loader"
        color="transparent"
        height="100%"
        width="100%"
      />
      <div
        v-if="$slots.title || $slots.actions"
        :class="{ 'cdm-Header-collapsed': isCollapsed || customDashboardState.isDragging }"
        class="cdm-Header"
      >
        <div class="cdm-Header_Left">
          <AppButton
            v-if="!hideCollapse && !customDashboardState.isDragging"
            :icon="isCollapsed ? 'arrow-right-simple-next' : 'arrow-down-simple-next'"
            :size="BUTTON_SIZES.SM"
            class="cdm-CollapseIcon"
            data-export-ignore
            height="24"
            remove-padding
            type="ghost"
            width="24"
            @click="isCollapsed = !isCollapsed"
          />
          <span v-if="$slots.title" class="cdm-Title oboard-truncated-text">
            <slot name="title" />
          </span>
        </div>
        <AppExportLogo />
        <div v-if="$slots.actions && !customDashboardState.isDragging">
          <slot name="actions" />
        </div>
      </div>
      <div
        v-if="$slots.content"
        v-show="!customDashboardState.isDragging && !isCollapsed"
        class="cdm-WrapperContent"
      >
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref } from 'vue'

import { BUTTON_SIZES } from '@/utils/components-configurations/app-button'
import { customDashboardStateInjectionKey } from '@/utils/injection-keys'

import AppExportLogo from '@/components/AppExportLogo'
import AppButton from '@/components/ui/AppButton/AppButton'
import AppIcon from '@/components/ui/AppIcon/AppIcon'
import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'CustomDashboardModuleItem'
})

defineProps({
  hideCollapse: {
    type: Boolean
  }
})

const isCollapsed = ref(false)

const customDashboardState = inject(customDashboardStateInjectionKey)
</script>

<style lang="scss" scoped>
.cdm-Container {
  display: flex;
  margin: var(--ob-cdmi-margin, 0);
  //gap: 4px;
  //margin: 0 $page-right-padding 0 4px;
}

.cdm-Wrapper {
  width: 100%;
  border-radius: $border-radius-lg;
  background: $white;
  overflow: hidden;
  border: var(--module-item-border, 1px solid var(--grey-2-next));
  // margin: 0 0 16px 0;
  &-reloading {
    position: relative;
    pointer-events: none;
  }
}
.cdm-Header {
  padding: var(--header-padding, 24px 20px);
  display: flex;
  align-items: var(--header-align-items, center);
  justify-content: space-between;
  gap: 8px;
  border-bottom: var(--header-border-bottom, 1px solid $grey-2-next);
  &-collapsed {
    --header-border-bottom: none;
  }
}
.cdm-Header_Left {
  display: grid;
  grid-template-columns: var(--header-left-grid-column, auto 1fr);
  gap: 8px;
  width: 100%;
}
.cdm-WrapperContent {
  padding: var(--content-padding, 32px);
  overflow: hidden;
}

.cdm-Title {
  font-weight: fw('semi-bold');
  font-size: $fs-22;
  line-height: 24px;
}

.cdm-CollapseIcon {
  cursor: pointer;
}

.cdm-Wrapper_Loader {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.cdm-DragItem {
  width: 32px;
  display: flex;
  padding-top: 24px;
  justify-content: center;
  position: relative;
  flex-shrink: 0;

  &:not(.cdm-Container:hover &) {
    opacity: 0;
  }
}

.cdm-Drag {
  cursor: grab;
  width: 24px;
  height: 24px;
  position: sticky;
  top: 24px;
}
.drag-trigger {
  //line-height: 0;
  height: 100%;
  display: block;
}
.cdm-Drag_Icon {
  // fix bug with drugging elements
  pointer-events: none;
}
</style>
